import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlCurrencyListRequest } from "../../models/service-models/currency/CurrencyListRequest";
import { CurrencyService } from "../../services/CurrencyService";

export type CurrencySelectProps = {
    onChange?: Function;
    value?: string | string[];
    mode?: "multiple" | "tags" | undefined;
}


export const CurrencySelect = memo(function CurrencySelect(props: CurrencySelectProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!data)
            refetch();
    }, [props]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getCurrencies"],
        () => {
            var request: mdlCurrencyListRequest = { pageSize: 0 };
            return CurrencyService.List(request);
        },
        {
            refetchOnWindowFocus: false,
            enabled: false
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    return (
        <>
            <Select
                mode={props.mode}
                loading={isLoading}
                allowClear
                onFocus={onFocus}
                size="large"
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseCurrencies")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data?.body?.data?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.code
                }))}
            />
        </>
    )
})